import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {MatSidenav} from '@angular/material/sidenav';
import {Observable} from 'rxjs';
import {UrbisoftNavbarConfig, UrbisoftActionItem} from '../../interfaces/urbisoft-main-structure-config.interface';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {
  @Input() navbarConfig: UrbisoftNavbarConfig;
  @ViewChild('sidenav') sidenav: MatSidenav;
  @Input() toggleSideBar: Observable<boolean>;
  @Input() isLoggedIn = false;

  constructor() {
  }

  ngOnInit(): void {
    this.toggleSideBar.pipe().subscribe(value => {
      if (value != null) {
        this.sidenav.toggle();
      }
    });
  }

  public close(): void {
    this.sidenav.close();
  }

  public action(item: UrbisoftActionItem): void {
    if (item.actionOnClick) {
      item.actionOnClick();
    }
    this.close();
  }
}
